import { render, staticRenderFns } from "./course-manage-progress-modal.vue?vue&type=template&id=1b80fbc3&scoped=true&"
import script from "./course-manage-progress-modal.vue?vue&type=script&lang=ts&"
export * from "./course-manage-progress-modal.vue?vue&type=script&lang=ts&"
import style0 from "./course-manage-progress-modal.vue?vue&type=style&index=0&id=1b80fbc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b80fbc3",
  null
  
)

export default component.exports